import { grey } from '@mui/material/colors';
import { createTheme, darken, lighten } from '@mui/material/styles';

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#423AA4B3',
    },
    secondary: {
      main: '#423AA4C7',
    },
  },
  typography: {
    fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Plus Jakarta Sans'), local('Plus Jakarta Sans'), url('/fonts/PlusJakartaSans-VariableFont_wght.ttf') format('ttf');
        }
      `,
    },
  }
})
const { breakpoints, typography: { pxToRem } } = defaultTheme

export interface ThemesType {
  [key: string]: any;
}

const themes: ThemesType = {
  default: {
    ...defaultTheme,
  }, pure: {
    ...defaultTheme,
    palette: {
      primary: {
        light: '#049DD9',
        main: '#0D5FA6',
        dark: '#223D73'
      },
      secondary: {
        light: '#049DD9',
        main: '#0D5FA6',
        dark: '#223D73'
      },
    },
  }
}

const customApp: ThemesType = {
  default: {
    toolbarBG: '#EAF0FF',
    backdropBG: '#F7F7FD',
    buttonBG: '#0D5FA6',
    buttonText: '#ffffff',
    instructionColor: grey[500],
    chart: {
      light: { bgColor: '#AAB1C288', borderColor: '#AAB1C2FF' },
      main: { bgColor: '#423aa488', borderColor: '#423aa4FF' },
      dark: { bgColor: '#2b256bdd', borderColor: '#2b256bff' },
    },
    primary: {
      main: '#423AA4B3',
      light: '#423AA4C7',
      dark: '#423AA4B3',
    },
  }, pure: {
    toolbarBG: '#ffffff',
    backdropBG: '#dadfe1',
    buttonBG: '#71b7f4',
    buttonText: '#08365e',
    instructionColor: grey[500],
    chart: {
      light: { bgColor: '#dadfe1', borderColor: '#d0e7fb' },
      main: { bgColor: '#71b7f4', borderColor: '#5aabf2' },
      dark: { bgColor: '#08365e', borderColor: '#062847' },
    },
    primary: {
      main: '#049DD9',
      light: '#0D5FA6',
      dark: '#223D73',
    },
  }, theParisGroupNw: { // https://coolors.co/visualizer/21618c-1b4f72-3498db-08365e-8cf06e
    // logoHeight: 150,
    toolbarBG: lighten('#3498DB', 0.9),
    backdropBG: lighten('#3498DB', 0.9),
    buttonBG: '#3498DB',
    buttonText: '#1B4F72',
    instructionColor: grey[500],
    chart: {
      light: { bgColor: '#3498DB', borderColor: darken('#3498DB', 0.5) },
      main: { bgColor: '#21618C', borderColor: darken('#21618C', 0.5) },
      dark: { bgColor: '#1B4F72', borderColor: darken('#1B4F72', 0.5) },
    },
    primary: {
      main: '#21618C',
      light: '#3498DB',
      dark: '#1B4F72',
    },
  }, traversepm: {
    toolbarBG: '#ffffff',
    backdropBG: '#7cfc00',
    buttonBG: '#7cfc00',
    buttonText: '#111c33',
    instructionColor: grey[500],
    chart: {
      light: { bgColor: '#7cfc00', borderColor: darken('#7cfc00', 0.5) },
      main: { bgColor: '#6eb200', borderColor: darken('#6eb200', 0.5) },
      dark: { bgColor: '#5b9e00', borderColor: darken('#5b9e00', 0.5) },
    },
    primary: {
      main: '#1e3566',
      light: '#21335c',
      dark: '#111c33',
    },
  }, gtlrealestate: {
    toolbarBG: '#ffffff',
    backdropBG: '#e7ab56',
    buttonBG: '#e7ab56',
    buttonText: '#223D73',
    instructionColor: grey[500],
    chart: {
      light: { bgColor: '#e7ab56', borderColor: darken('#e7ab56', 0.5) },
      main: { bgColor: '#71b7f4', borderColor: darken('#71b7f4', 0.5) },
      dark: { bgColor: '#08365e', borderColor: darken('#08365e', 0.5) },
    },
    primary: {
      main: '#0e2237',
      light: '#0D5FA6',
      dark: '#223D73',
    },
  }
}


/*export const domainColor = (domain: string | undefined) => {
  if (domain?.toLowerCase() === 'pure') return {
    light: '#049DD9', main: '#0D5FA6', dark: '#223D73'
  }
  return { light: '#FFD700', main: '#6A63B7', dark: '#FFD700' }
}*/

export const customAppTheme = (domain: string | undefined) => customApp[domain ?? 'default']

export default themes